export const PRECAUTION_COLOR_PALETTE = [
  "#E8912D",
  "#FDEE00",
  "#5B9BD5",
  "#CC2E8E",
  "#000000",
  "#6BA272",
  "#7030A0",
  "#7F6D5A",
] as const;

export const DEFAULT_PRECAUTION_COLOR: string = PRECAUTION_COLOR_PALETTE[0];
